import React from 'react'
import { StackView } from '@planningcenter/tapestry-react'
import { PageHeading, Heading, Text, Link } from '../../shared/typography'

const page = () => {
  return (
    <StackView axis="vertical" spacing={2}>
      <PageHeading>Getting Help</PageHeading>

      <Heading anchored id="community-help">Community Help</Heading>
      <Text>
        Join the #api channel in our{' '}
        <Link to="https://www.planningcenter.com/community" external>
          Community Slack
        </Link>{' '}
        to share your ideas and get help from other Planning Center API users.
      </Text>

      <Heading anchored id="reporting-bugs">Reporting Bugs</Heading>
      <Text>
        If you have found a bug in the API, please{' '}
        <Link to="https://github.com/planningcenter/developers/issues" external>
          open a Github Issue
        </Link>{' '}
        in our developers repo.
      </Text>

      <Heading anchored id="getting-help">Getting Help</Heading>
      <Text>
        If you have questions about the API or specific endpoints, please{' '}
        <Link to="https://github.com/planningcenter/developers/issues" external>
          open a Github Issue
        </Link>
        . Please note we cannot help you debug your application.
      </Text>
    </StackView>
  )
}

export default page
